/* Haken — interacciones del tema */
(function () {
  'use strict';

  /* Filtro por categoría: botones [data-hk-filtro] + tarjetas [data-hk-cat] */
  function initFiltros(scope) {
    scope.querySelectorAll('[data-hk-filtro-grupo]').forEach(function (grupo) {
      var destinoSel = grupo.getAttribute('data-hk-destino');
      var destino = destinoSel ? document.querySelector(destinoSel) : null;
      if (!destino) return;
      var etiqueta = grupo.getAttribute('data-hk-etiqueta') ? document.querySelector(grupo.getAttribute('data-hk-etiqueta')) : null;
      var conteo = grupo.getAttribute('data-hk-conteo') ? document.querySelector(grupo.getAttribute('data-hk-conteo')) : null;
      var botones = grupo.querySelectorAll('[data-hk-filtro]');

      function aplicar(cat, texto) {
        var visibles = 0;
        destino.querySelectorAll('[data-hk-cat]').forEach(function (item) {
          var ok = cat === 'todos' || item.getAttribute('data-hk-cat') === cat;
          item.classList.toggle('hk-oculto', !ok);
          if (ok) visibles++;
        });
        botones.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-hk-filtro') === cat ? 'true' : 'false'); });
        if (etiqueta && texto) etiqueta.textContent = texto;
        if (conteo) conteo.textContent = visibles + (visibles === 1 ? ' resultado' : ' resultados');
        if (destino.classList.contains('hk-rail')) destino.scrollTo({ left: 0, behavior: 'smooth' });
      }

      botones.forEach(function (b) {
        b.addEventListener('click', function () {
          aplicar(b.getAttribute('data-hk-filtro'), b.getAttribute('data-hk-label'));
        });
      });
      var inicial = grupo.querySelector('[data-hk-filtro][aria-pressed="true"]') || botones[0];
      if (inicial) aplicar(inicial.getAttribute('data-hk-filtro'), inicial.getAttribute('data-hk-label'));
    });
  }

  /* Carrusel horizontal con flechas */
  function initRails(scope) {
    scope.querySelectorAll('[data-hk-rail]').forEach(function (rail) {
      var caja = rail.closest('[data-hk-rail-caja]') || document;
      var prev = caja.querySelector('[data-hk-rail-prev]');
      var next = caja.querySelector('[data-hk-rail-next]');
      if (!prev || !next) return;

      function paradas() {
        var kids = Array.prototype.filter.call(rail.children, function (k) { return !k.classList.contains('hk-oculto'); });
        if (!kids.length) return [0];
        var base = kids[0].offsetLeft;
        var max = Math.max(0, rail.scrollWidth - rail.clientWidth);
        var out = [];
        kids.forEach(function (k) {
          var v = Math.min(Math.round(k.offsetLeft - base), Math.round(max));
          if (out.indexOf(v) === -1) out.push(v);
        });
        return out;
      }
      function mover(dir) {
        var st = paradas(), cur = rail.scrollLeft, i = 0;
        st.forEach(function (o, n) { if (o <= cur + 4) i = n; });
        var t = Math.max(0, Math.min(st.length - 1, i + dir));
        rail.scrollTo({ left: st[t], behavior: 'smooth' });
      }
      function bordes() {
        var max = rail.scrollWidth - rail.clientWidth;
        prev.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft >= max - 4 || max <= 0;
      }
      prev.addEventListener('click', function () { mover(-1); });
      next.addEventListener('click', function () { mover(1); });
      rail.addEventListener('scroll', bordes);
      window.addEventListener('resize', bordes);
      bordes();
    });
  }

  /* Carrusel del home */
  function initSlides(scope) {
    scope.querySelectorAll('[data-hk-slider]').forEach(function (slider) {
      var slides = slider.querySelectorAll('[data-hk-slide]');
      var puntos = slider.querySelectorAll('[data-hk-punto]');
      var i = 0, timer = null;
      if (slides.length < 2) { if (slides[0]) slides[0].classList.add('is-on'); return; }
      var auto = parseInt(slider.getAttribute('data-hk-auto') || '0', 10);
      function ir(n) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) { s.classList.toggle('is-on', k === i); });
        puntos.forEach(function (p, k) { p.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
      }
      puntos.forEach(function (p, k) { p.addEventListener('click', function () { ir(k); reiniciar(); }); });
      var prev = slider.querySelector('[data-hk-prev]'), next = slider.querySelector('[data-hk-next]');
      if (prev) prev.addEventListener('click', function () { ir(i - 1); reiniciar(); });
      if (next) next.addEventListener('click', function () { ir(i + 1); reiniciar(); });
      function reiniciar() {
        if (!auto) return;
        clearInterval(timer);
        timer = setInterval(function () { ir(i + 1); }, auto);
      }
      ir(0); reiniciar();
    });
  }

  /* Selector de vehículo (marca / modelo / año / versión) */
  var HK_VERSIONES = ['Gasolina o diésel', 'Híbrido', 'Eléctrico'];
  function initVehiculo(scope) {
    scope.querySelectorAll('[data-hk-vehiculo]').forEach(function (caja) {
      var datos;
      try { datos = JSON.parse(caja.querySelector('[data-hk-vehiculo-datos]').textContent); } catch (e) { return; }
      var marca = caja.querySelector('[data-hk-marca]');
      var modelo = caja.querySelector('[data-hk-modelo]');
      var anio = caja.querySelector('[data-hk-anio]');
      var version = caja.querySelector('[data-hk-version]');
      if (!version && anio) {
        var campoAnio = anio.closest('label') || anio.parentNode;
        var campoVer = campoAnio.cloneNode(true);
        var rot = campoVer.querySelector('span');
        if (rot) rot.textContent = 'Versión';
        version = campoVer.querySelector('select');
        version.setAttribute('data-hk-version', '');
        version.removeAttribute('data-hk-anio');
        version.innerHTML = '';
        campoAnio.parentNode.insertBefore(campoVer, campoAnio.nextSibling);
      }
      var aviso = caja.querySelector('[data-hk-compat]');
      var boton = document.querySelector(caja.getAttribute('data-hk-boton') || '');
      var textoOk = caja.getAttribute('data-hk-texto-ok') || 'Pieza confirmada para {v}.';
      var textoBoton = boton ? boton.getAttribute('data-hk-texto-listo') : null;
      var textoEspera = boton ? boton.textContent.trim() : null;

      Object.keys(datos).forEach(function (m) { marca.appendChild(opcion(m, m)); });
      function opcion(v, t) { var o = document.createElement('option'); o.value = v; o.textContent = t; return o; }
      function limpiar(sel, ph) { sel.innerHTML = ''; sel.appendChild(opcion('', ph)); }

      marca.addEventListener('change', function () {
        limpiar(modelo, 'Elige modelo'); limpiar(anio, 'Elige año'); limpiar(version, 'Elige versión');
        modelo.disabled = !marca.value; anio.disabled = true; version.disabled = true;
        if (marca.value && datos[marca.value]) {
          (datos[marca.value].modelos || []).forEach(function (mo) { modelo.appendChild(opcion(mo, mo)); });
        }
        evaluar();
      });
      modelo.addEventListener('change', function () {
        limpiar(anio, 'Elige año'); limpiar(version, 'Elige versión');
        anio.disabled = !modelo.value; version.disabled = true;
        if (modelo.value && datos[marca.value]) {
          (datos[marca.value].anios || []).forEach(function (a) { anio.appendChild(opcion(a, a)); });
        }
        evaluar();
      });
      anio.addEventListener('change', function () {
        limpiar(version, 'Elige versión');
        version.disabled = !anio.value;
        if (anio.value) {
          ((datos[marca.value] || {}).tipos || HK_VERSIONES).forEach(function (t) { version.appendChild(opcion(t, t)); });
        }
        evaluar();
      });
      version.addEventListener('change', evaluar);

      function evaluar() {
        var listo = !!(marca.value && modelo.value && anio.value && version.value);
        var v = marca.value + ' ' + modelo.value + ' ' + anio.value + ' ' + version.value.toLowerCase();
        if (aviso) {
          aviso.classList.toggle('is-ok', listo);
          aviso.textContent = listo ? textoOk.replace('{v}', v) : (aviso.getAttribute('data-hk-espera') || aviso.textContent);
        }
        if (boton) {
          boton.disabled = !listo;
          if (textoBoton) boton.textContent = listo ? textoBoton : textoEspera;
          var campo = document.querySelector('[data-hk-vehiculo-campo]');
          if (campo) campo.value = listo ? v : '';
        }
      }
      modelo.disabled = true; anio.disabled = true; version.disabled = true;
      limpiar(version, 'Elige versión');
      evaluar();
    });
  }

  /* Galería de ficha */
  function initGaleria(scope) {
    scope.querySelectorAll('[data-hk-galeria]').forEach(function (gal) {
      var grande = gal.querySelector('[data-hk-galeria-grande]');
      gal.querySelectorAll('[data-hk-mini]').forEach(function (mini) {
        mini.addEventListener('click', function () {
          grande.src = mini.getAttribute('data-hk-src');
          gal.querySelectorAll('[data-hk-mini]').forEach(function (m) { m.setAttribute('aria-pressed', m === mini ? 'true' : 'false'); });
        });
      });
    });
  }

  /* Cantidad */
  function initCantidad(scope) {
    scope.querySelectorAll('[data-hk-cantidad]').forEach(function (caja) {
      var salida = caja.querySelector('output');
      var campo = caja.querySelector('input[type="hidden"], input[name="quantity"]');
      caja.querySelectorAll('[data-hk-paso]').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = Math.max(1, Math.min(9, parseInt(salida.textContent, 10) + parseInt(b.getAttribute('data-hk-paso'), 10)));
          salida.textContent = n;
          if (campo) campo.value = n;
        });
      });
    });
  }

  function init(scope) {
    scope = scope || document;
    initFiltros(scope); initRails(scope); initSlides(scope);
    initVehiculo(scope); initGaleria(scope); initCantidad(scope);
  }

  document.addEventListener('DOMContentLoaded', function () { init(document); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
